import React from 'react';

import { flagStyles } from '../settings';

const SvgGP = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2040px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgGP;
